var moment = require('moment');

function isValidDate(dateString) {
  if (dateString != undefined && dateString != '') {
    var date = moment(dateString, "DD/MM/YYYY"),
        firstDate = moment('01/01/2000', 'DD/MM/YYYY'),
        now = moment();

    return (date.isValid() && date.isSameOrBefore(now) && date.isSameOrAfter(firstDate))
  } else {
    return false
  }
};

$(document).ready(function () {
  var $input = $('#payment_date_expedition_date');

  $input.mask('99/99/9999');

  $input.on('focusin', function(){
    $(this).next().next().find('li').text("");
  });

  $input.on('keyup focusout', function(){
    var $this = $(this);

    if ($this.val().length == 10) {
      if (!isValidDate($this.val())) {
        $this.next().next().find('li').text("Data inválida");
      }
    }
  });

  return false;
});